__turbopack_context__.v({
  "flake": "_0ELkXq_flake",
  "root": "_0ELkXq_root",
});
